var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('thg-billing-creditor-selection')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }